"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MainWebsiteEvents;
(function (MainWebsiteEvents) {
    MainWebsiteEvents["GcSessionXhrFetch"] = "gcsession-xhr-fetch";
    MainWebsiteEvents["GcSessionXhrFinished"] = "gcsession-xhr-finished";
    MainWebsiteEvents["CatalogueLoaded"] = "catalogue-loaded";
    MainWebsiteEvents["FeatureFlagUpdated"] = "page-feature";
    MainWebsiteEvents["RedirectPage"] = "redirect-page";
    MainWebsiteEvents["CleanUpStorageKey"] = "magento__clean-up--storage-key";
})(MainWebsiteEvents = exports.MainWebsiteEvents || (exports.MainWebsiteEvents = {}));
var AccountsEvents;
(function (AccountsEvents) {
    AccountsEvents["CustomerLogout"] = "accounts--customer-logout";
    AccountsEvents["CustomerLogin"] = "accounts--customer-login";
    AccountsEvents["CustomerNotLoggedIn"] = "accounts--customer-not-logged-in";
})(AccountsEvents = exports.AccountsEvents || (exports.AccountsEvents = {}));
var CatalogueEvents;
(function (CatalogueEvents) {
    CatalogueEvents["UsedLegacyFilterUrl"] = "catalogue--used-legacy-filter-url";
    CatalogueEvents["LegacyMagentoCatalogueLoaded"] = "catalogue--legacy-magento-catalogue-loaded";
    CatalogueEvents["StyleItemClicked"] = "catalogue--style-item-clicked";
    CatalogueEvents["StyleItemsViewed"] = "catalogue--style-items-viewed";
    CatalogueEvents["StyleItemsFiltered"] = "catalogue--style-items-filtered";
    CatalogueEvents["StyleItemsSearched"] = "catalogue--style-items-searched";
})(CatalogueEvents = exports.CatalogueEvents || (exports.CatalogueEvents = {}));
var CheckoutEvents;
(function (CheckoutEvents) {
    CheckoutEvents["LoginAttempt"] = "checkout__login--attempt";
    CheckoutEvents["LoginError"] = "checkout__login--error";
    CheckoutEvents["LoginSuccess"] = "checkout__login--success";
})(CheckoutEvents = exports.CheckoutEvents || (exports.CheckoutEvents = {}));
var OnDemandEvents;
(function (OnDemandEvents) {
    OnDemandEvents["AddToCart"] = "ondemand--add-to-cart";
    OnDemandEvents["CartClose"] = "ondemand--close-cart";
    OnDemandEvents["CartFrameHidden"] = "ondemand--cart-frame-hidden";
    OnDemandEvents["CartFrameShown"] = "ondemand--cart-frame-shown";
    OnDemandEvents["CartItemAdded"] = "ondemand--cart-item-added";
    OnDemandEvents["CartItemRemoved"] = "ondemand--cart-item-removed";
    OnDemandEvents["CartOpen"] = "ondemand--open-cart";
    OnDemandEvents["CartProceedToCheckout"] = "ondemand--proceed-to-checkout";
    OnDemandEvents["CartRemoveItem"] = "ondemand--remove-from-cart";
    OnDemandEvents["CartUpdated"] = "ondemand--cart-updated";
    OnDemandEvents["CartUpdateItem"] = "ondemand--update-from-cart";
    OnDemandEvents["CartUpdateProducts"] = "ondemand-update-products";
    OnDemandEvents["CheckoutAcceptedTerms"] = "ondemand--checkout-accepted-terms";
    OnDemandEvents["CheckoutAddressValidationFailed"] = "ondemand--checkout-address-validation-failed";
    OnDemandEvents["CheckoutAuthToLeave"] = "ondemand--checkout-auth-to-leave";
    OnDemandEvents["CheckoutBillToSameAddress"] = "ondemand--checkout-bill-to-same-address";
    OnDemandEvents["CheckoutClickedAlreadyHaveAnAccount"] = "ondemand--checkout-clicked-already-have-account";
    OnDemandEvents["CheckoutClickedUseCouponCode"] = "ondemand--checkout-clicked-opt-use-coupon";
    OnDemandEvents["CheckoutContinueShoppingClicked"] = "ondemand--checkout-continue-shopping";
    OnDemandEvents["CheckoutCouponCodeApplied"] = "ondemand--checkout-coupon-code-applied";
    OnDemandEvents["CheckoutCouponCodeRejected"] = "ondemand--checkout-coupon-code-rejected";
    OnDemandEvents["CheckoutEditMyInformation"] = "ondemand--checkout-edit-my-information";
    OnDemandEvents["CheckoutManualAddressInput"] = "ondemand--checkout-manual-address-input";
    OnDemandEvents["CheckoutNavigateToOldCheckout"] = "ondemand--opt-for-old-checkout";
    OnDemandEvents["CheckoutNumberOfItemsInTheBag"] = "ondemand--checkout-number-of-items-in-bag";
    OnDemandEvents["CheckoutPageLoaded"] = "ondemand--checkout-page";
    OnDemandEvents["CheckoutPageLoadedAsGuest"] = "ondemand--checkout-page-guest";
    OnDemandEvents["CheckoutPageLoadedLoggedIn"] = "ondemand--checkout-page-logged-in";
    OnDemandEvents["CheckoutPaymentMethodCancelled"] = "ondemand--checkout-payment-method-cancelled";
    OnDemandEvents["CheckoutPaymentMethodError"] = "ondemand--checkout-payment-method-error";
    OnDemandEvents["CheckoutPaymentMethodSelected"] = "ondemand--checkout-payment-method-selected";
    OnDemandEvents["CheckoutPlaceOrderError"] = "ondemand--checkout-place-order-error";
    OnDemandEvents["CheckoutPlaceOrderInitialized"] = "ondemand--checkout-place-order-initialized";
    OnDemandEvents["CheckoutPlaceOrderSuccess"] = "ondemand--checkout-place-order-success";
    OnDemandEvents["CheckoutProceededToPayment"] = "ondemand--checkout-proceeded-to-payment";
    OnDemandEvents["CheckoutSetShippingPostcode"] = "ondemand--checkout-set-shipping-postcode";
    OnDemandEvents["CheckoutSetIdentify"] = "ondemand--checkout-set-identify";
    OnDemandEvents["CheckoutStoreCreditApplied"] = "ondemand--checkout-store-credit-applied";
    OnDemandEvents["CheckoutStoreCreditRemoved"] = "ondemand--checkout-store-credit-removed";
    OnDemandEvents["CheckoutTermsAndConditionsChecked"] = "ondemand--checkout-terms-and-conditions-checked";
    OnDemandEvents["CleanUpStorageKey"] = "ondemand__clean-up--storage-key";
    OnDemandEvents["DisableBackupDress"] = "ondemand--disable-backup-dress";
    OnDemandEvents["EnableBackupDress"] = "ondemand--enable-backup-dress";
    OnDemandEvents["UpdatedCartItem"] = "ondemand--updated-cart-item";
})(OnDemandEvents = exports.OnDemandEvents || (exports.OnDemandEvents = {}));
var StylePageEvents;
(function (StylePageEvents) {
    StylePageEvents["PageFinishedLoading"] = "style-page--page-finished-loading";
})(StylePageEvents = exports.StylePageEvents || (exports.StylePageEvents = {}));
var SubscriptionEvents;
(function (SubscriptionEvents) {
    SubscriptionEvents["AddProductsToFavourites"] = "subscription--add-products-to-favourites";
    SubscriptionEvents["AddToSubscriptionBox"] = "subscription--add-to-box";
    SubscriptionEvents["BoxAlreadyOrdered"] = "subscription--box-already-ordered";
    SubscriptionEvents["BoxClose"] = "subscription--close-box";
    SubscriptionEvents["BoxConfirmed"] = "subscription--confirm-box";
    SubscriptionEvents["BoxFrameHidden"] = "subscription--box-frame-hidden";
    SubscriptionEvents["BoxFrameShown"] = "subscription--box-frame-shown";
    SubscriptionEvents["BoxItemAdded"] = "subscription--box-item-added";
    SubscriptionEvents["BoxItemRemoved"] = "subscription--box-item-removed";
    SubscriptionEvents["BoxProceedToCheckout"] = "subscription--proceed-to-checkout";
    SubscriptionEvents["BoxRemoveItem"] = "subscription--remove-from-box";
    SubscriptionEvents["BoxTooManyItems"] = "subscription--box-too-many-items";
    SubscriptionEvents["BoxUpdated"] = "subscription--box-updated";
    SubscriptionEvents["FetchCustomerSubscriptionFailed"] = "subscription--fetch-customer-subscription-failed";
    SubscriptionEvents["FetchProductAvailabilitiesFailed"] = "subscription--fetch-product-availabilities-failed";
    SubscriptionEvents["FetchProductAvailabilitiesSuccess"] = "subscription--fetch-product-availabilities-success";
    SubscriptionEvents["MyGcPremiumAddPaymentMethod"] = "subscription--my-gc-premium-add-payment-method";
    SubscriptionEvents["MyGcPremiumAddPaymentMethodFailed"] = "subscription--my-gc-premium-add-payment-method-failed";
    SubscriptionEvents["SignUpCreateAccountPageLoaded"] = "subscription--sign-up-create-account-page-loaded";
    SubscriptionEvents["SignUpLoginPageLoaded"] = "subscription--sign-up-login-page-loaded";
    SubscriptionEvents["SignUpPaymentSubmitted"] = "subscription--sign-up-payment-submitted";
    SubscriptionEvents["SignUpPlanChange"] = "subscription--sign-up-plan-change";
    SubscriptionEvents["SignUpPlanChosen"] = "subscription--sign-up-plan-chosen";
    SubscriptionEvents["SubscriptionPlaceOrderSuccess"] = "subscription--place-order-success";
    SubscriptionEvents["SubscriptionPlaceOrderError"] = "subscription--place-order-error";
})(SubscriptionEvents = exports.SubscriptionEvents || (exports.SubscriptionEvents = {}));
var MyAccountCancelMyOrderEvents;
(function (MyAccountCancelMyOrderEvents) {
    MyAccountCancelMyOrderEvents["CancelMyOrderConfirmedTerms"] = "cancel-my-order--confirmed-terms";
    MyAccountCancelMyOrderEvents["CancelMyOrderConfirmedReason"] = "cancel-my-order--confirmed-reason";
    MyAccountCancelMyOrderEvents["CancelMyOrderConfirmedCancellation"] = "cancel-my-order--confirmed-cancellation";
})(MyAccountCancelMyOrderEvents = exports.MyAccountCancelMyOrderEvents || (exports.MyAccountCancelMyOrderEvents = {}));
var MyAccountOrderDetailsEvents;
(function (MyAccountOrderDetailsEvents) {
    MyAccountOrderDetailsEvents["OrderDetailsLoaded"] = "order-details--loaded";
})(MyAccountOrderDetailsEvents = exports.MyAccountOrderDetailsEvents || (exports.MyAccountOrderDetailsEvents = {}));
var MyAccountRefundMyOrderEvents;
(function (MyAccountRefundMyOrderEvents) {
    MyAccountRefundMyOrderEvents["RefundMyOrderConfirmedTerms"] = "refund-my-order--confirmed-terms";
    MyAccountRefundMyOrderEvents["RefundMyOrderConfirmedReason"] = "refund-my-order--confirmed-reason";
    MyAccountRefundMyOrderEvents["RefundMyOrderConfirmedRefund"] = "refund-my-order--confirmed-refund";
})(MyAccountRefundMyOrderEvents = exports.MyAccountRefundMyOrderEvents || (exports.MyAccountRefundMyOrderEvents = {}));
